import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebaseConfig';
let lists = [];
let unsubscribe = null;
const subscribers = new Set();
export function useGateLists() {
    const [value, setValue] = useState(lists);
    useEffect(() => {
        subscribers.add(setValue);
        if (!unsubscribe) unsubscribe = onSnapshot(collection(db, 'gateLists'), snapshot => {
            lists = snapshot.docs.map(item => ({ id: item.id, ...item.data() }));
            subscribers.forEach(callback => callback(lists));
        }, console.error);
        setValue(lists);
        return () => {
            subscribers.delete(setValue);
            if (!subscribers.size) { unsubscribe?.(); unsubscribe = null; lists = []; }
        };
    }, []);
    return value;
}
